import {memo} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {ArticleCard} from 'modules/blog/components/ArticleCard';
import {Button} from 'components/Button';
import {TArticlePreview} from 'modules/blog/types';
import {Box, Col, Row} from 'components/Grid';
import classNames from 'classnames';

interface IBlogCategoryPageProps {
    title?: string;
    articles?: TArticlePreview[];
    onLoadMore: () => void;
    isDataLoading?: boolean;
    isLoadMoreAvailable?: boolean;
    category?: string;
    categoryId?: number;
}

export const BlogCategoryPage = memo<IBlogCategoryPageProps>(function BlogCategoryPage({
    articles = [],
    title,
    onLoadMore,
    isDataLoading = false,
    isLoadMoreAvailable = false,
    category,
    categoryId,
}) {
    const hasArticles = 0 < articles?.length;

    return (
        <Box>
            <Row>
                <Col>
                    <div>
                        <div className={style.titleWrap}>
                            <Typography
                                className={'article-preview__header'}
                                data-autotest-target={'blog-category-title'}
                                data-autotest-target-id={'blog-category-title'}
                                element={'h1'}
                                variant={'h1'}
                            >
                                {title}
                            </Typography>
                        </div>
                        <div className={style.content}>
                            {hasArticles ? (
                                articles.map((item, index) => (
                                    <div key={item.id} className={style.articleCard}>
                                        <ArticleCard
                                            article={item}
                                            category={category}
                                            id={index + 1}
                                            to={item.link || item.url || ''}
                                        />
                                    </div>
                                ))
                            ) : (
                                <Typography variant={'h3'}>Ничего не найдено...</Typography>
                            )}
                        </div>
                        {isLoadMoreAvailable && hasArticles && (
                            <div className={style.footer}>
                                <Button
                                    backColor={'gray'}
                                    className={classNames(style.button, 'article-preview__more')}
                                    data-autotest-target={'blog-category-show-all-btn'}
                                    data-autotest-target-id={`blog-category-show-all-btn-${categoryId}`}
                                    isLoading={isDataLoading}
                                    onClick={onLoadMore}
                                >
                                    <Typography variant={'badge-m'}>ПОКАЗАТЬ EЩE</Typography>
                                </Button>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
        </Box>
    );
});
